
import { Heart } from "lucide-react";
import { FamilyProfileDialog } from "@/components/FamilyProfileDialog";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";

interface ParentsInfoSectionProps {
  familyProfile: any;
  onProfileUpdate?: () => void;
}

export function ParentsInfoSection({ familyProfile, onProfileUpdate }: ParentsInfoSectionProps) {
  const { language } = useLanguage();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold flex items-center">
        <Heart className="h-5 w-5 mr-2 text-red-500" />
        {t('family.parents', language)}
      </h3>
      
      {familyProfile ? (
        <div className="space-y-2">
          {familyProfile.motherName && (
            <div className="flex justify-between border-b pb-2">
              <span className="text-muted-foreground">{language === 'ja' ? '母親の名前:' : 'Mother\'s Name:'}</span>
              <span className="font-medium">{familyProfile.motherName}</span>
            </div>
          )}
          
          {familyProfile.fatherName && (
            <div className="flex justify-between border-b pb-2">
              <span className="text-muted-foreground">{language === 'ja' ? '父親の名前:' : 'Father\'s Name:'}</span>
              <span className="font-medium">{familyProfile.fatherName}</span>
            </div>
          )}
        </div>
      ) : (
        <div className="text-center p-4 border border-dashed rounded-lg">
          <p className="text-muted-foreground mb-2">
            {language === 'ja' ? '両親の情報はまだありません' : 'No parents information yet'}
          </p>
          <FamilyProfileDialog onComplete={onProfileUpdate} />
        </div>
      )}
    </div>
  );
}
